/* @flow */
import {cappedTotal} from '../../utils/resultsCountText';

import type {IntlShape} from 'react-intl';

type Props = {
    intl: IntlShape,
    resultsCount?: ?number
};

export default function seeResultsMessage({intl, resultsCount}: Props): string {
    let resultCount;
    let plus;

    if (typeof resultsCount !== 'undefined' && resultsCount !== null) {
        resultCount = resultsCount < cappedTotal ? resultsCount : cappedTotal;
        plus = resultCount > cappedTotal - 1 ? '+' : '';

        return intl.formatMessage(
            {
                id: 'seeResultsWithCount',
                defaultMessage:
                    '{resultCount, plural, one {See 1 Result} other {See {resultCount}{plus} Results}}'
            },
            {resultCount, plus}
        );
    }
    return intl.formatMessage({
        id: 'seeResults',
        defaultMessage: 'See Results'
    });
}
